import React, { useState } from "react";
import format from "date-fns/format";
import printJS from "print-js";

import { NO_DATA_FOUND, DOC_ICON } from "../../../../constants";
import { parseDateToLocal } from "../../../../utils/parseDateTime";
import constants from "../../../../constants";

import ProfileIcon from "../../../../components/uiElements/icons/profileIcons/ProfileIcon";
import Modals from "../../../../components/uiElements/popupModal/modal";
import FileViewer from "../../Appointments/InCall/Chat/FileViewer";

const PatientFileList = ({ files, searchFiles, searchValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [fileUrl, setFileUrl] = useState();

  const fetchedFiles = !searchValue
    ? files || searchFiles
    : searchFiles || files;

  const handleDownload = async (fileUrl, event) => {
    event.preventDefault();
    const response = await fetch(fileUrl);
    if (response.status === 200) {
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileUrl?.split("/")?.pop()?.split("_").slice(1).join("_");
      document.body.appendChild(link);
      link.click();
      link.remove();
      return { success: true };
    }
  };

  return (
    <>
      <Modals
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        onBackdropClick={true}
        onRequestClose={() => setIsOpen(false)}
        styles={{
          content: {
            minWidth: "70%",
            maxWidth: "70%",
            minHeight: "90%",
            maxHeight: "90%",
            overflowY: "scroll",
          },
        }}
        title={fileUrl?.split("/")?.pop()?.split("_").slice(1).join("_")}
      >
        <React.Fragment>
          <button
            onClick={() => setIsOpen(false)}
            className="close fileClose mt-n2"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <FileViewer
            fileType={fileUrl?.split(".")?.pop()?.toLowerCase()}
            url={fileUrl}
          />
        </React.Fragment>
      </Modals>
      {fetchedFiles.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        <table class="table mt-3">
          <thead>
            <tr>
              <th>Notes</th>
              <th>Date</th>
              <th>Time</th>
              <th>Doctor Name</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {fetchedFiles.map(file => (
              <tr>
                <td
                  onClick={() => {
                    setFileUrl(file?.file_url);
                    setIsOpen(true);
                  }}
                >
                  <img src={DOC_ICON} alt="document_icon" />
                  <span className="ml-2">
                    {file?.file_url
                      ?.split("/")
                      ?.pop()
                      ?.split("_")
                      .slice(1)
                      .join("_")}
                  </span>
                </td>
                <td>
                  {format(parseDateToLocal(file?.created_at), "MM-dd-yyyy")}
                </td>
                <td>{format(parseDateToLocal(file?.created_at), "hh:mm a")}</td>
                <td>
                  {file?.record_type === "ATTACHMENT"
                    ? `${file?.first_name} ${file?.last_name}`
                    : "-"}
                </td>
                <td onClick={e => handleDownload(file?.file_url, e)}>
                  <ProfileIcon type="download" />
                </td>
                <td
                  onClick={() =>
                    printJS({
                      printable: file?.file_url,
                      type: constants.DOCUMENT_IMAGE_SUPPORTED_TYPES.includes(
                        file?.file_url?.split(".")?.pop()?.toLowerCase()
                      )
                        ? "image"
                        : "pdf",
                      documentTitle: file?.file_url
                        ?.split("/")
                        ?.pop()
                        ?.split("_")
                        .slice(1)
                        .join("_"),
                    })
                  }
                >
                  <ProfileIcon type="print" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default PatientFileList;
